import request from './request'

/**
 * 获取公开学校信息（校名和校徽）
 */
export const getPublicSchoolInfo = () => {
    return request.get('/school/public/')
}

/**
 * 获取当前家长绑定的学生列表
 */
export const getMyStudents = () => {
    return request.get('/v2/academic/students/m/children/')
}
